import { colorsPrimitive as colors } from "./colorsPrimitive";

const alpha = {
	alpha_white_10: "rgba(255, 255, 255, 0.1)",
	alpha_white_20: "rgba(255, 255, 255, 0.2)",
	alpha_white_30: "rgba(255, 255, 255, 0.3)",
	alpha_white_40: "rgba(255, 255, 255, 0.4)",
	alpha_white_50: "rgba(255, 255, 255, 0.5)",
	alpha_white_60: "rgba(255, 255, 255, 0.6)",
	alpha_white_70: "rgba(255, 255, 255, 0.7)",
	alpha_white_80: "rgba(255, 255, 255, 0.8)",
	alpha_white_90: "rgba(255, 255, 255, 0.9)",
	alpha_white_100: colors.primary.base.white,

	alpha_black_10: "rgba(0, 0, 0, 0.1)",
	alpha_black_20: "rgba(0, 0, 0, 0.2)",
	alpha_black_30: "rgba(0, 0, 0, 0.3)",
	alpha_black_40: "rgba(0, 0, 0, 0.4)",
	alpha_black_50: "rgba(0, 0, 0, 0.5)",
	alpha_black_60: "rgba(0, 0, 0, 0.6)",
	alpha_black_70: "rgba(0, 0, 0, 0.7)",
	alpha_black_80: "rgba(0, 0, 0, 0.8)",
	alpha_black_90: "rgba(0, 0, 0, 0.9)",
	alpha_black_100: colors.primary.base.black,
};

const alphaDark = {
	alpha_white_10_dark: "rgba(12, 14, 18, 0.1)",
	alpha_white_20_dark: "rgba(12, 14, 18, 0.2)",
	alpha_white_30_dark: "rgba(12, 14, 18, 0.3)",
	alpha_white_40_dark: "rgba(12, 14, 18, 0.4)",
	alpha_white_50_dark: "rgba(12, 14, 18, 0.5)",
	alpha_white_60_dark: "rgba(12, 14, 18, 0.6)",
	alpha_white_70_dark: "rgba(12, 14, 18, 0.7)",
	alpha_white_80_dark: "rgba(12, 14, 18, 0.8)",
	alpha_white_90_dark: "rgba(12, 14, 18, 0.9)",
	alpha_white_100_dark: colors.primary.grayDark[950],

	alpha_black_10_dark: alpha.alpha_white_10,
	alpha_black_20_dark: alpha.alpha_white_20,
	alpha_black_30_dark: alpha.alpha_white_30,
	alpha_black_40_dark: alpha.alpha_white_40,
	alpha_black_50_dark: alpha.alpha_white_50,
	alpha_black_60_dark: alpha.alpha_white_60,
	alpha_black_70_dark: alpha.alpha_white_70,
	alpha_black_80_dark: alpha.alpha_white_80,
	alpha_black_90_dark: alpha.alpha_white_90,
	alpha_black_100_dark: colors.primary.base.white,
};

export const colorsAlpha = { ...alpha, ...alphaDark };
